import { render, staticRenderFns } from "./comments_list_right.vue?vue&type=template&id=49824f97&scoped=true"
import script from "./comments_list_right.vue?vue&type=script&lang=js"
export * from "./comments_list_right.vue?vue&type=script&lang=js"
import style0 from "./comments_list_right.vue?vue&type=style&index=0&id=49824f97&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49824f97",
  null
  
)

export default component.exports